import { useTranslation } from "react-i18next";
import "../../../i18n";
import { useDocumentValidation } from "../../../api/queries";
import { ValidationBody, ValidationSummary } from "./bodies/ValidationBody";

export { sortFailures } from "./bodies/ValidationBody";

export function ValidationPanel({ docId }: { docId: string }) {
  const { t } = useTranslation();
  const validation = useDocumentValidation(docId);

  return (
    <section className="card">
      <div className="card-head">
        <h2 className="grow">{t("documents.inspector.validation.title", "Validation")}</h2>
        <ValidationSummary result={validation.data} />
      </div>

      <div className="card-body">
        <ValidationBody result={validation.data} isError={validation.isError} />
      </div>
    </section>
  );
}
